// src/pages/ClientData/components/FileActionsMenu.js
import React, { useEffect, useRef, useState } from 'react';

const FileActionsMenu = ({ onDownload, onTranscrever, onGuardar, transcrevendo, guardando }) => {
  const [aberto, setAberto] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!aberto) return undefined;

    const handleClickFora = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setAberto(false);
      }
    };

    document.addEventListener('mousedown', handleClickFora);
    return () => document.removeEventListener('mousedown', handleClickFora);
  }, [aberto]);

  const executar = (acao) => {
    setAberto(false);
    acao();
  };

  return (
    <div className="cd-file-actions" ref={menuRef}>
      <button
        type="button"
        className="cd-icon-btn"
        title="Ações do ficheiro"
        onClick={() => setAberto((v) => !v)}
      >
        ⋮
      </button>
      {aberto && (
        <div className="cd-file-actions-menu">
          <button type="button" onClick={() => executar(onDownload)}>
            ⬇️ Download ficheiro
          </button>
          <button type="button" onClick={() => executar(onTranscrever)} disabled={transcrevendo}>
            {transcrevendo ? '⏳ A transcrever...' : '📝 Transcrever'}
          </button>
          <button type="button" onClick={() => executar(onGuardar)} disabled={guardando}>
            {guardando ? '⏳ A guardar...' : '💾 Salvar em Meus Documentos'}
          </button>
        </div>
      )}
    </div>
  );
};

export default FileActionsMenu;
